import { marqueeHeadlines } from '@/mocks/gossip';

const portraits = [
  { img: 'https://readdy.ai/api/search-image?query=editorial%20celebrity%20portrait%20silhouette%20with%20face%20heavily%20blurred%2C%20crimson%20backlight%20behind%20head%2C%20dark%20smoky%20background%2C%20high%20contrast%20tabloid%20cover%2C%20grainy%20film%2C%20moody%20drama&width=360&height=460&seq=hero-p1&orientation=portrait', tag: '同居疑云' },
  { img: 'https://readdy.ai/api/search-image?query=blurred%20male%20singer%20silhouette%20under%20red%20spotlight%2C%20confetti%20in%20air%2C%20dark%20concert%20background%2C%20tabloid%20documentary%20style%2C%20warm%20grainy%20tone%2C%20dramatic&width=360&height=460&seq=hero-p2&orientation=portrait', tag: '番位录音' },
  { img: 'https://readdy.ai/api/search-image?query=mysterious%20person%20in%20hood%20holding%20phone%20with%20chat%20glow%20on%20face%2C%20identity%20hidden%2C%20dark%20amber%20ambiance%2C%20gossip%20evidence%20editorial%2C%20grainy%20film%20noir&width=360&height=460&seq=hero-p3&orientation=portrait', tag: '群聊截图' },
  { img: 'https://readdy.ai/api/search-image?query=blurred%20actress%20silhouette%20behind%20frosted%20glass%20window%2C%20warm%20studio%20light%20through%20curtain%2C%20dark%20red%20tone%2C%20documentary%20portrait%2C%20grainy%2C%20mysterious%20aura&width=360&height=460&seq=hero-p4&orientation=portrait', tag: '双标实锤' },
  { img: 'https://readdy.ai/api/search-image?query=shadow%20figure%20in%20backlit%20hallway%20holding%20old%20microphone%2C%20deep%20maroon%20and%20gold%20lighting%2C%20undercover%20documentary%20portrait%2C%20grainy%20film%2C%20mysterious&width=360&height=460&seq=hero-p5&orientation=portrait', tag: '偷税名单' },
  { img: 'https://readdy.ai/api/search-image?query=blurred%20celebrity%20walking%20airport%20terminal%20under%20flash%2C%20night%20window%20lights%2C%20warm%20amber%20and%20red%20tones%2C%20surveillance%20editorial%20portrait%2C%20grainy&width=360&height=460&seq=hero-p6&orientation=portrait', tag: '两副面孔' },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-ink-950">
      {/* 背景氛围 */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 top-0 h-[420px] w-[420px] rounded-full bg-flame-900/50 blur-[120px]" />
        <div className="absolute -right-16 bottom-0 h-[380px] w-[380px] rounded-full bg-gold-700/30 blur-[120px]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_20%,rgba(124,31,19,0.25),transparent_55%)]" />
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:px-8 lg:py-16">
        {/* 文案优先 */}
        <div className="animate-rise">
          <div className="inline-flex items-center gap-2 rounded-full border border-flame-500/40 bg-flame-500/10 px-3.5 py-1.5 text-xs font-bold text-flame-300">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-flame-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-flame-400" />
            </span>
            吃瓜现场 · 持续更新中
          </div>

          <h1 className="mt-6 font-display text-3xl font-black leading-[1.15] tracking-tight text-paper-50 md:text-5xl">
            全网最全的
            <span className="text-flame-400">明星黑料</span>
            挖掘现场
            <br className="hidden md:block" />
            每一锤，都有迹可循
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-7 text-paper-200/85 md:text-base">
            实锤合集、证据整理、截图汇总、录音曝光、聊天记录，按人物与事件逐条归档。
            我们不做断章取义，只把时间线、图源与原始素材摆在一起，等你来亲自考古。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#latest"
              className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full bg-flame-500 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-flame-600"
            >
              吃最新的一口瓜
              <i className="ri-arrow-right-line ml-2 text-base" />
            </a>
            <a
              href="#hammer"
              className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full border border-gold-500/50 px-6 py-3 text-sm font-bold text-gold-200 transition-colors hover:bg-gold-500/10"
            >
              看实锤合集索引
            </a>
          </div>

          {/* 数字 */}
          <dl className="mt-9 grid max-w-md grid-cols-3 gap-4">
            {[
              { n: '1287', label: '累计实锤帖' },
              { n: '9632', label: '录音 / 聊天档案' },
              { n: '360万+', label: '吃瓜群众参与' },
            ].map((s) => (
              <div key={s.label} className="border-l-2 border-flame-500/50 pl-3">
                <dt className="order-2 text-xs text-paper-300/80">{s.label}</dt>
                <dd className="font-display text-2xl font-black text-gold-300">{s.n}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 封面瀑布 coll */}
        <div className="relative hidden h-[520px] lg:block">
          <div className="absolute left-0 top-6 grid grid-cols-3 gap-3">
            {portraits.map((p, i) => (
              <div
                key={i}
                className="group relative overflow-hidden rounded-xl"
                style={{ transform: `translateY(${(i % 3) * 18}px)`, animationDelay: `${i * 80}ms` }}
              >
                <div className="relative h-[224px] w-[150px] overflow-hidden rounded-xl">
                  <img src={p.img} alt={p.tag} className="h-full w-full object-cover object-top" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-950/90 via-ink-950/10 to-transparent" />
                  <span className="absolute bottom-2 left-2 right-2 text-center text-xs font-bold text-paper-50">
                    {p.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* 浮动标签卡 */}
          <div className="absolute -right-2 top-8 rotate-2 rounded-xl border border-gold-500/40 bg-ink-900/90 px-4 py-3 text-sm backdrop-blur">
            <p className="text-xs text-gold-300">今日最热录音</p>
            <p className="mt-1 font-bold text-paper-50">资方饭局 · 改番内幕</p>
            <div className="mt-2 flex gap-1">
              {[4, 8, 6, 10, 7, 9, 10, 8].map((h, i) => (
                <span key={i} className="w-1 rounded-full bg-flame-400" style={{ height: `${h * 2}px` }} />
              ))}
            </div>
          </div>
          <div className="absolute -left-3 bottom-20 -rotate-2 rounded-xl border border-flame-500/40 bg-ink-900/90 px-4 py-3 backdrop-blur">
            <p className="flex items-center gap-1.5 text-xs text-paper-300">
              <i className="ri-fire-line text-flame-400" />
              话题热度
            </p>
            <p className="mt-1 font-display text-lg font-black text-flame-300">#顶流塌房倒计时</p>
          </div>
        </div>
      </div>

      {/* 跑马灯 */}
      <div className="relative border-t border-paper-50/10 bg-flame-600 py-2.5">
        <div className="flex items-center">
          <span className="z-10 flex shrink-0 items-center gap-1.5 rounded-full bg-ink-950 px-3 py-1 text-xs font-black text-gold-300">
            <i className="ri-notification-4-line" />
            滚动快讯
          </span>
          <div className="relative ml-3 flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap pl-6">
              {[...marqueeHeadlines, ...marqueeHeadlines].map((m, i) => (
                <span key={i} className="flex items-center gap-2 text-sm font-semibold text-paper-50">
                  <em className="not-italic rounded bg-ink-950/30 px-1.5 py-0.5 text-[11px] font-black text-gold-100">
                    {m.kind}
                  </em>
                  {m.text}
                  <i className="ri-more-fill text-paper-50/50" />
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}